<template>
    <div>
        <b-tabs v-model="activeTab">
            <b-tab-item label="Detalles">
                <CompanyDetails
                :detailsEndpoint="detailsEndpoint"
                :countryList="countryList"
                :cityList="cityList"
                :details="details"
                @fetchDetails="fetchDetails"/>
            </b-tab-item>

            <b-tab-item label="Canales de pago">
                <PaymentChannels
                :paymentListUrl="paymentListUrl"
                :paymentCreateUrl="paymentCreateUrl"
                :details="details"
                :companyEndpoint="detailsEndpoint"
                :mpAuthUrl="mpAuthUrl"
                :ppCredCreate="ppCredCreate"
                :ppCredDetails="ppCredDetails"
                @fetchDetails="fetchDetails"/>
            </b-tab-item>

            <b-tab-item v-if="isStore" label="Tipo de envios">
                <Shipment
                :shipmentCreateUrl="shipmentCreateUrl"
                :shipmentDetailUrl="shipmentDetailUrl"
                :shipmentListUrl="shipmentListUrl"
                />
            </b-tab-item>

            <b-tab-item label="Cupones">
                <Coupons
                :currencyEndpoint="currencyEndpoint"
                :couponsDetail="couponsDetail"
                :couponsListCreate="couponsListCreate"/>
            </b-tab-item>

            <b-tab-item label="Miembros">
                <Members
                :memberList="memberList"
                :invitationList="invitationList"
                :invitationDetail="invitationDetail"/>
            </b-tab-item>

            <b-tab-item label="Campos de orden">
                <OrderCustomFields
                :company="details"
                :customOrderFieldsUrl="customOrderFieldsUrl"
                :customOrderFieldsDetailUrl="customOrderFieldsDetailUrl"
                :customOrderFieldsOptionsUrl="customOrderFieldsOptionsUrl"
                :customOrderFieldsOptionsDetailUrl="customOrderFieldsOptionsDetailUrl"
                @updateDetails="saveDetails"
                />
            </b-tab-item>

        </b-tabs>
    </div>
</template>

<script>
import CompanyDetails from './components/CompanyDetails.vue'
import Members from './components/Members.vue'
import PaymentChannels from "./components/PaymentChannels.vue"
import Shipment from "./components/Shipment.vue"
import Coupons from "./components/Coupons.vue"
import OrderCustomFields from "./components/OrderCustomFields.vue"
import {getHandler, patchHandler} from "./../../../services/http"

export default {
    components:{
        CompanyDetails,
        Members,
        PaymentChannels,
        Shipment,
        Coupons,
        OrderCustomFields
    },
    props:{
        detailsEndpoint:{
            type:String,
            default:''
        },
        countryList:{
            type:String,
            default:''
        },
        cityList:{
            type:String,
            default:''
        },
        memberList:{
            type:String,
            default:''
        },
        invitationList:{
            type:String,
            default:''
        },
        invitationDetail:{
            type:String,
            default:''
        },
        paymentListUrl:{
            type:String,
            default:''
        },
        paymentCreateUrl:{
            type:String,
            default:""
        },
        mpChannel:{
            type:String,
            default:""
        },
        cashChannel:{
            type:String,
            default:""
        },
        shipmentCreateUrl:{
            type:String,
            default:""
        },
        shipmentListUrl:{
            type:String,
            default:""
        },
        shipmentDetailUrl:{
            type:String,
            default:""
        },
        mpAuthUrl:{
            type:String,
            default:""
        },
        ppCredDetails:{
            type:String,
            default:""
        },
        ppCredCreate:{
            type:String,
            default:""
        },
        couponsListCreate:{
            type:String,
            default:""
        },
        couponsDetail:{
            type:String,
            default:""
        },
        currencyEndpoint:{
            type:String,
            default:""
        },
        isStore:{
            type:String,
            default:""
        },
        customOrderFieldsUrl:{
            type:String,
            default:""
        },
        customOrderFieldsDetailUrl:{
            type:String,
            default:""
        },
        customOrderFieldsOptionsUrl:{
            type:String,
            default:""
        },
        customOrderFieldsOptionsDetailUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            activeTab:0,
            details:{}
        }
    },

    methods:{
        async fetchDetails(){
            this.loading = true
            let resp = await getHandler(this.detailsEndpoint, {error:false, success:false})
            this.details = resp
            this.loading = false
        },
        async saveDetails(details){
            let msg = {
                resource:'notify'
            }
            let resp = await patchHandler(this.detailsEndpoint, details, {error:msg, success:msg})
            this.fetchDetails()
        },
    },

    created(){
        this.fetchDetails()
    }

}
</script>

<style lang="scss">
@import "./../../../scss/main.scss";
</style>